import * as api from './adapter';
import {
  forOwner, forClient, rowForOwner, rowForClient, keyIncluded,
} from './convertors/vacancyContacts';

// CREW-1240 — employees whose name and phone go on an owner's vacancy ads.
// Same rows for both cards: the owner tab filters by owner and includes the
// client; the employee block filters by client and includes the owner.
const PAGE = { size: 999 };
const CLIENT_FIELDS = { clients: 'name,status,phone' };
const OWNER_FIELDS = { owners: 'title,short_title' };

const link = (ownerId, clientId, include, fields) => api.create({
  type: 'vacancy_contacts',
  relationships: {
    owner: { data: { id: String(ownerId), type: 'owners' } },
    client: { data: { id: String(clientId), type: 'clients' } },
  },
}, { query: { include, fields } });

export default {
  /**
   * The owner card: who is ticked for this owner, with status and phone.
   * @param {string|number} ownerId
   * @returns {Promise<{data: Array, meta: {count: number}}>}
   */
  forOwner: async (ownerId) => {
    const { data } = await api.read('vacancy_contacts', {
      query: {
        include: 'client', fields: CLIENT_FIELDS, filter: { owner_id: ownerId }, page: PAGE,
      },
    });

    return { data: forOwner(data), meta: { count: data.data.length } };
  },

  /**
   * The employee card: which owners' ads may carry this person.
   * @param {string} clientId
   * @returns {Promise<{data: Array, meta: {count: number}}>}
   */
  forClient: async (clientId) => {
    const { data } = await api.read('vacancy_contacts', {
      query: {
        include: 'owner', fields: OWNER_FIELDS, filter: { client_id: clientId }, page: PAGE,
      },
    });

    return { data: forClient(data), meta: { count: data.data.length } };
  },

  createForOwner: async (ownerId, clientId) => {
    const { data } = await link(ownerId, clientId, 'client', CLIENT_FIELDS);
    return rowForOwner(data.data, keyIncluded(data.included));
  },

  createForClient: async (ownerId, clientId) => {
    const { data } = await link(ownerId, clientId, 'owner', OWNER_FIELDS);
    return rowForClient(data.data, keyIncluded(data.included));
  },

  delete: (id) => api.destroy({ id, type: 'vacancy_contacts' }),
};
